import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { RouterModule } from '@angular/router';

import { HisCoreModule } from 'hisng';

import { AppComponent } from './app.component';

import { AppRoutesModule } from './app.routes';
import { CommonCoreModule } from './cs/psv/common/common-core.module';

@NgModule( {
    declarations: [
        AppComponent
    ],
    imports: [
        AppRoutesModule,
        BrowserModule,
        BrowserAnimationsModule,
        FormsModule,
        HttpClientModule,
        RouterModule,
        HisCoreModule,
        CommonCoreModule
    ],
    providers: [
    ],
    bootstrap: [AppComponent]
} )
export class AppModule { }
